//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false, _: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('tagger', ['TrackingService',
    function(TrackingService) {
      return {
        restrict: 'E',
        scope: {
          disabled: '@',
          placeholder: '@',
          tagAddedCallback: '&',
          tagRemovedCallback: '&',
          tagSearchCallback: '&',
          tags: '=',
          trackingValue: '=',
          showAddButton: '@',
          showAddedHeading: '@',
          emptyStateText: '@',
          noPermission: '<',
          noPermissionMessage: '@',
          labelActionMessage: '@',
          addLabelsOnBlur: '<',
        },
        template: require('@partials/tagger.html'),
        controller: ['$scope', '$http', '$log', 'TaggerSanitization',
          function($scope, $http, $log, TaggerSanitization) {
            let addTag;

            $scope.tagAddedCallback = $scope.tagAddedCallback || angular.noop;
            $scope.tagRemovedCallback = $scope.tagRemovedCallback || angular.noop;

            if (!$scope.tagSearchCallback) {
              $log.warn('<tagger /> has no search callback set');
            }

            $scope.model = {
              tag: '',
              labelAction: $scope.labelActionMessage || 'ADDED',
            };

                        //
                        // Twitter Typeahead configuration and callbacks
                        //
            $scope.model.typeaheadConfig = {
              currentQuery() {
                return $scope.model.tag;
              },
              events: {
                selected($event, data) {
                  $scope.model.typeaheadConfig.context.onAdd($event, data);
                },
              },
              context: {
                onAdd($event, data) {
                  addTag(data.tag);
                  $scope.model.tag = '';
                  $scope.$broadcast('twitter-typeahead:reset');
                },
              },
              templates: {
                suggestion: { html: require('@partials/tagger-suggestion.html') },
              },
              searchTags: _.debounce((query, defer) => {
                $scope.tagSearchCallback({ query }).then((data) => {
                  defer.resolve(data);
                });
              }, 200),
            };

                        //
                        // Private Methods
                        //
            addTag = function(tag) {
              tag = tag.trim();
              if (tag && $scope.tags.indexOf(tag) === -1) {
                $scope.tags.push(tag);
                $scope.tagAddedCallback({ tag });

                TrackingService.recordEvent(
                                    $scope.trackingCategory,
                                    $scope.trackingActionAddTag,
                                    $scope.trackingLabelAddTag,
                                    $scope.trackingValue);
              }
            };

                        //
                        // ViewModel Methods
                        //
            $scope.model.onKeyPress = function($event) {
                            // Check for enter pressed
              if ($event.which === 13 || $event.keyCode === 13) {
                $scope.model.addTagsFromInput();

                                // prevent enter key event from propagating because it will cause parent form submission.
                $event.preventDefault();
              }
            };

            $scope.model.onBlur = function() {
              if ($scope.addLabelsOnBlur && $scope.model.tag && $scope.model.tag.length > 0) {
                $scope.model.addTagsFromInput();
              }
            };

            $scope.model.addTagClicked = function() {
              $scope.model.addTagsFromInput();
            };

            $scope.model.addTagsFromInput = function() {
              $scope.model.tagError = null;
                            // Split all spaces and commas (grouping multiple delimiters into a single split)
              $scope.model.tag.split(/[\s,]+/).forEach((el) => {
                const newTag = el.trim();
                if (TaggerSanitization.valid(newTag)) {
                  addTag(newTag);
                } else {
                  $scope.model.tagError =
                                        'Labels can only contain letters, numbers, dashes (-), or underscores (_). e.g. flat_lay1';
                }
              });

              if (!$scope.model.tagError) {
                $scope.model.tag = '';
                $scope.$broadcast('twitter-typeahead:reset');
              }
            };

            $scope.model.removeTag = function(tag) {
              let ndx;
              if (tag) {
                ndx = $scope.tags.indexOf(tag);
                if (ndx !== -1) {
                  $scope.tags.splice(ndx, 1);
                  $scope.tagRemovedCallback({ tag });

                  TrackingService.recordEvent(
                                        $scope.trackingCategory,
                                        $scope.trackingActionRemoveTag,
                                        $scope.trackingLabelRemoveTag,
                                        $scope.trackingValue);
                }
              }
            };
          },
        ],
        link($scope, $element, $attrs) {
                    // Initialize to default actions if none are set.
          $scope.trackingActionAddTag = $attrs.trackingActionAddTag || TrackingService.ACTION_ADD_TAG;
          $scope.trackingActionRemoveTag = $attrs.trackingActionRemoveTag || TrackingService.ACTION_REMOVE_TAG;

                    // Set tracking labels if provided. It's okay if these are undefined.
          $scope.trackingLabelAddTag = $attrs.trackingLabelAddTag;
          $scope.trackingLabelRemoveTag = $attrs.trackingLabelRemoveTag;

          $scope.trackingCategory = $attrs.trackingCategory || TrackingService.CATEGORY_TAGGER;
        },
      };
    },
  ]);
})();
